<template>
	<div
		class="om-notifications"
		ref="drawer"
		:class="show ? 'om-drawer-open' : 'om-drawer-closed'"
	>
		<transition name="notifications-fade">
			<div
				v-if="show"
				class="overlay"
				@click="toggleNotifications"
				:style="overlayStyle"
			></div>
		</transition>
		<transition name="notifications-slide">
			<div
				v-if="show"
				:style="drawerStyle"
				class="drawer"
			>
				<div class="omapi-card-title capital">{{ title }}</div>
				<notifications-list
					class="omapi-card-content"
					:notificationsToShow="notifications"
					:inDrawer="true"
					@remove="remove"
					@clicked="toggleNotifications"
				/>
			</div>
		</transition>
	</div>
</template>

<script lang="js">
import { notifications } from '@/notifications/mixins/notifications'

export default  {
	mixins : [ notifications ],
	props  : {
		show : {
			type : Boolean,
			default () {
				return false
			},
		},
	},
	mounted () {
		document.addEventListener('keydown', this.escapeListener)
		document.addEventListener('click', this.documentClick)
	},
	watch : {
		show (newValue) {
			if (newValue) {
				this.addBodyClass()
			} else {
				this.removeBodyClass()
			}
		},
		notifications (newVal, oldVal) {
			if (!newVal.length && oldVal.length && this.show) {
				this.toggleNotifications()
			}
		},
	},
	computed : {
		overlayStyle () {
			const left = document.getElementById('adminmenuback').offsetWidth + 'px'
			let top    = document.getElementById('wpadminbar').offsetHeight
			top += document.querySelector('.omapi-plugin-header').offsetHeight
			top += 'px'

			return {
				top,
				left,
			}
		},
		drawerStyle () {
			const { top } = this.overlayStyle
			return { top }
		},
		dismissBtn () {
			return this.hasNotifications ? 'Dismiss All' : 'Close'
		},
	},
	methods : {
		toggleNotifications () {
			this.$bus.$emit('notificationsToggle')
		},
		escapeListener (event) {
			if ('Escape' === event.key && this.show) {
				this.toggleNotifications()
			}
		},
		addBodyClass () {
			document.body.classList.add('om-show-notifications')
		},
		removeBodyClass () {
			document.body.classList.remove('om-show-notifications')
		},
		documentClick (event) {
			if (!this.show) {
				return
			}

			const $target  = event && event.target ? event.target : null
			const $drawer = this.$refs.drawer
			const $trigger = document.getElementById('om-notifications-trigger')
			if (
				!$drawer ||
				$drawer === $target ||
				$drawer.contains($target) ||
				$drawer === $trigger ||
				$trigger.contains($target)
			) {
				return
			}

			this.toggleNotifications()
		},
	},
}
</script>

<style lang="scss">
.om-show-notifications {
	height: 100%;
	overflow: hidden;
}
</style>
<style lang="scss" scoped>
@import '../../assets/scss/variables';
.overlay {
	background-color: $font_secondary-color;
	opacity: 0.5;
	position: fixed;
	top: 106px;
	left: 160px;
	display: block;
	right: 0;
	bottom: 0;
	z-index: 2;
	transition: 0.5s;
}
.drawer {
	width: 572px;
	min-width: 300px;
	background: $color_white;
	position: fixed;
	top: 106px;
	left: auto;
	right: 0;
	bottom: 0;
	z-index: 9991;
	overflow: scroll;
	transition: 0.5s;
	&.notifications-slide-enter, &.notifications-slide-leave-to {
		right: -600px;
	}
	&.notifications-slide-enter, &.notifications-slide-leave-to {
		right: -600px;
	}
}
.omapi-has-alert .overlay, .omapi-has-alert .drawer {
	top: 144px;
}

.notifications-fade-enter-active, .notifications-fade-leave-active {
	transition: opacity .5s;
}
.notifications-fade-enter, .notifications-fade-leave-to {
	opacity: 0;
}

.notifications-slide-enter-active, .notifications-slide-leave-active {
	transition: all .5s ease-in-out;
}
</style>
